<template>
    <div>
        <navbar-header/>
        <div class="flex-grow-1 body container-fluid d-flex flex-column">
        <b-row class="flex-grow-1">
            <b-col md="4" class="m-auto">
                <h3>Войти</h3>
                <b-form @submit="onSubmit">
                    <b-form-group id="emailInputGroup"
                                  label="Логин:"
                                  label-for="emailInput">
                        <b-form-input id="emailInput"
                                      type="text"
                                      v-model="form.email"
                                      required
                                      placeholder="Введите почту">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group id="passwordInputGroup"
                                  label="Пароль:"
                                  label-for="passwordInput">
                        <b-form-input id="passwordInput"
                                      type="password"
                                      v-model="form.password"
                                      required
                                      placeholder="Введите пароль">
                        </b-form-input>
                    </b-form-group>
                    <b-alert :show="showError" variant="danger">{{errorMessage}}</b-alert>
                    <b-button class="w-100" type="submit"  variant="primary">Войти</b-button>
                </b-form>
            </b-col>
        </b-row>
        <b-row>
          <!-- :settings="settingsYandex" -->
          <yandex-map
            :coords="[57.137170, 65.546001]"
            zoom="12"
            style="width: 200px; height: 200px;"
          />
        </b-row>
        </div>
    </div>
</template>

<script>
import NavbarHeader from '@/components/NavbarHeader'
import { SIGNIN_MUTATION } from '../constants/graphql'
import { ERR_LOGIN, ERR_COMMON } from '../constants/errorMessages'
import lodash from 'lodash'
import loginControl from '../helpers/loginControl'

export default {
  name: 'LoginLayout',
  data () {
    return {
      showError: false,
      errorMessage: '',
      form: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    onSubmit (e) {
      e.preventDefault()
      this.lodashedSigning()
    },
    lodashedSigning: lodash.debounce(function () {
      this.userLogin()
    }, 500),
    userLogin () {
      this.showError = false
      const { email, password } = this.form
      this.$user.set({ role: 'cooker' })
      this.$apollo.mutate({
        mutation: SIGNIN_MUTATION,
        variables: {
          email,
          password
        }
      }).then((result) => {
        let jwtToken = result.data.signin.jwtToken
        if (jwtToken !== null) {
          this.$userControl.login(jwtToken)
          loginControl.setLoginTimestamp()
        } else {
          this.errorMessage = ERR_LOGIN.WRONG_CRIDENTIALS
          this.showError = true
        }
      }).catch((error) => {
        if (error.message === 'Network error: Failed to fetch') {
          this.errorMessage = ERR_COMMON.CONNECTION_REFUSED
          this.showError = true
        }
        console.error(error)
      })
    }
  },
  components: {
    NavbarHeader
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/LoginLayout.vue